import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import AudiencesAPI from '../../api/audiences';

export const state = {
  records: [],
  contactsCounts: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getAudiences(_state) {
    return _state.records;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAudienceById: _state => id => {
    return _state.records.find(record => record.id === Number(id)) || {};
  },
  getContactsCount: _state => id => {
    return _state.contactsCounts[id] || 0;
  },
};

export const actions = {
  get: async function getAudiences({ commit }) {
    commit(types.SET_AUDIENCE_UI_FLAG, { isFetching: true });
    try {
      const response = await AudiencesAPI.get();
      commit(types.SET_AUDIENCES, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_AUDIENCE_UI_FLAG, { isFetching: false });
    }
  },

  create: async function createAudience({ commit }, audienceObj) {
    commit(types.SET_AUDIENCE_UI_FLAG, { isCreating: true });
    try {
      const response = await AudiencesAPI.create(audienceObj);
      commit(types.ADD_AUDIENCE, response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_AUDIENCE_UI_FLAG, { isCreating: false });
    }
  },

  update: async function updateAudience({ commit }, { id, ...updateObj }) {
    commit(types.SET_AUDIENCE_UI_FLAG, { isUpdating: true });
    try {
      const response = await AudiencesAPI.update(id, updateObj);
      commit(types.EDIT_AUDIENCE, response.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_AUDIENCE_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async function deleteAudience({ commit }, id) {
    commit(types.SET_AUDIENCE_UI_FLAG, { isDeleting: true });
    try {
      await AudiencesAPI.delete(id);
      commit(types.DELETE_AUDIENCE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_AUDIENCE_UI_FLAG, { isDeleting: false });
    }
  },

  fetchContactsCount: async function fetchContactsCount({ commit }, id) {
    try {
      const response = await AudiencesAPI.getContactsCount(id);
      commit(types.SET_AUDIENCE_CONTACTS_COUNT, {
        id,
        count: response.data.contacts_count,
      });
    } catch (error) {
      // Ignore error
    }
  },
};

export const mutations = {
  [types.SET_AUDIENCE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_AUDIENCES]: MutationHelpers.set,
  [types.ADD_AUDIENCE]: MutationHelpers.create,
  [types.EDIT_AUDIENCE]: MutationHelpers.update,
  [types.DELETE_AUDIENCE]: MutationHelpers.destroy,

  [types.SET_AUDIENCE_CONTACTS_COUNT](_state, { id, count }) {
    _state.contactsCounts = {
      ..._state.contactsCounts,
      [id]: count,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
